import { render, staticRenderFns } from "./EligibilityEvent.vue?vue&type=template&id=25da8a88&scoped=true&"
import script from "./EligibilityEvent.vue?vue&type=script&lang=js&"
export * from "./EligibilityEvent.vue?vue&type=script&lang=js&"
import style0 from "./EligibilityEvent.vue?vue&type=style&index=0&id=25da8a88&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25da8a88",
  null
  
)

export default component.exports